import React from 'react';
import './PropertyCard.css';
import { Bed, Bath, Maximize, MapPin, Search } from 'lucide-react';
import { motion } from 'framer-motion';

const PropertyCard = ({ property, animateIndex = 0, active = false, onClick, onViewDetails, onMouseEnter, onMouseLeave, id }) => {
  const {
    image,
    title,
    listingType,
    price,
    city,
    district,
    details,
  } = property;

  const isSale = (listingType || '').toLowerCase().includes('sat');

  // Extract counts for icons
  const beds = details.odaSayisi || '-';
  const baths = details.banyoSayisi || '-';
  const sqft = details.metreKare ? `${details.metreKare} m²` : '-';

  const handleViewDetails = (e) => {
    e.stopPropagation();
    onViewDetails?.(property);
  };

  return (
    <motion.div
      layout
      id={id}
      className={`property-card appear ${active ? 'active' : ''}`}
      style={{ '--i': animateIndex }}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClick?.(e); }}
    >
      <div className="property-card-image-container">
        {image && <img src={image} alt={title} className="property-image" />}
        <div className="property-badges">
          <span className={`property-badge ${isSale ? 'badge-sale' : 'badge-rent'}`}>
            {listingType}
          </span>
        </div>
      </div>

      <div className="property-card-content">
        <button className="icon-view-details-button" onClick={handleViewDetails} aria-label="İncele">
          <Search size={18} />
        </button>

        <div className="property-price-container">
          <span className="property-price">{price}</span>
        </div>
        
        <h3 className="property-title">{title}</h3>
        
        <div className="property-location-container mobile-hide">
          <MapPin className="location-icon" size={16} />
          <span className="property-location">
            {(city || '')}{city && district ? ' / ' : ''}{district || ''}
          </span>
        </div>

        <div className="property-specs-container">
          <div className="spec-item">
            <Bed size={16} />
            <span>{beds}</span>
          </div>
          <div className="spec-item">
            <Bath size={16} />
            <span>{baths}</span>
          </div>
          <div className="spec-item">
            <Maximize size={16} />
            <span>{sqft}</span>
          </div>
        </div>

        <button className="view-details-button desktop-only-btn" onClick={handleViewDetails}>
          İncele
        </button>
      </div>
    </motion.div>
  );
};


export default PropertyCard;

